import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import configAPIService from 'v2/services/configAPI';

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const NewApiKeyDialog = ({ open, onClose, onConfirm }: IProps) => {
  const [accepted, setAccepted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const updateKey = useCallback(async () => {
    setLoading(true);
    configAPIService.updateApiKey().subscribe(
      () => {
        toast.success('API key atualizada com sucesso');
        setLoading(false);
        setAccepted(false);
        onConfirm();
      },
      (error) => {
        toast.error(error);
        setLoading(false);
      }
    );
  }, [onConfirm]);

  return (
    <Dialog aria-labelledby='customized-dialog-title' open={open} maxWidth={'sm'}>
      <DialogTitle id='customized-dialog-title'>
        <div>ATENÇÃO</div>
      </DialogTitle>
      <DialogContent dividers>
        <p>
          Você está a um passo de executar <strong>UMA AÇÃO QUE NÃO PODE SER DESFEITA</strong>.
        </p>
        <p>Ao gerar uma nova API Key, todas as suas integrações com a nossa API deixarão de funcionar. Fique atento as recomendações abaixo:</p>
        <br />
        <li>Antes de gerar um nova API Key, identifique todos os sistemas que integram com a Eduzz através da nossa API;</li>
        <li>Realize essa operação em um horário de menor fluxo para sua operação, por exemplo, durante a madrugada, o impacto tende a ser menor;</li>
        <li> Após gerar uma nova API Key, informe-a em todos os seus sistemas que integram com a Eduzz; </li>
        <li>
          Anote a nova API Key que será gerada em um local seguro,{' '}
          <strong>ELA SÓ ESTARÁ DISPONÍVEL NESTA TELA, NO MOMENTO DA GERAÇÃO E NÃO SERÁ SALVA EM NUNHUM OUTRO LOCAL</strong>.
        </li>
        <br />
        <Checkbox onChange={(e) => setAccepted(e.target.checked)} />
        Li e entendi todas as recomendações acima.
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose} disabled={loading}>
          Não, quero manter a API key
        </Button>
        <Button color='secondary' variant='contained' type='submit' disabled={loading || !accepted} onClick={updateKey}>
          Sim, gerar uma nova API key
          {loading && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
